export enum NamedRoutes {
  Home = "Home",
  Login = "Login",
}
